"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAgentMemoryCreateInputSchema = exports.APosAgentMemorySchema = exports.APosAgentTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosAgentTypeSchema = zod_1.z.enum([
    'inventory_advisor', 'pricing_optimizer', 'reorder_agent',
    'customer_insights', 'promotion_engine', 'general',
]);
exports.APosAgentMemorySchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    memoryId: id_schema_1.EntityIdSchema,
    agentType: exports.APosAgentTypeSchema,
    locationId: id_schema_1.EntityIdSchema.optional(),
    key: zod_1.z.string().min(1).max(200),
    value: zod_1.z.unknown(),
    context: zod_1.z.string().max(2000).optional(),
    confidence: zod_1.z.number().min(0).max(1).optional(),
    expiresAt: zod_1.z.number().optional(),
    source: zod_1.z.enum(['observation', 'inference', 'user_input', 'system']).default('observation'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosAgentMemoryCreateInputSchema = zod_1.z.object({
    agentType: exports.APosAgentTypeSchema,
    locationId: id_schema_1.EntityIdSchema.optional(),
    key: zod_1.z.string().min(1).max(200),
    value: zod_1.z.unknown(),
    context: zod_1.z.string().max(2000).optional(),
    confidence: zod_1.z.number().min(0).max(1).optional(),
    expiresAt: zod_1.z.number().optional(),
    source: zod_1.z.enum(['observation', 'inference', 'user_input', 'system']).optional(),
});
//# sourceMappingURL=agent-memory.schema.js.map